export default __webpack_public_path__ + "static/media/bag1.ebcf08a8.svg";